import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { ProgressBarType } from './models/progress-bar-type';
import { BehaviorSubject, Observable } from 'rxjs';

@Component({
  selector: 'ife-progress-bar',
  templateUrl: './progress-bar.component.html',
  styleUrls: ['./progress-bar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProgressBarComponent implements OnInit {
  @Input()
  public stepOrder;
  @Input()
  public step$: Observable<any>;
  @Input()
  public barType: ProgressBarType;
  @Input()
  public isCompleted$: Observable<any>;

  public currentIndex$: BehaviorSubject<number> = new BehaviorSubject<number>(0);
  public progressBarType = ProgressBarType;

  constructor() {}

  ngOnInit(): void {
    this.step$.subscribe((value) => {
      const index = this.getCurrentStepIndex(value);
      this.currentIndex$.next(index);
    });
  }

  /* Checks which index the current step has with the 'evSimulatorStepsOrder' array.
   * returns index number of current step.*/
  private getCurrentStepIndex(stepName: string): number {
    const newIndex = this.stepOrder.findIndex((stepInfo) => stepInfo.step === stepName);
    if (newIndex < 0) {
      return 0;
    }
    return newIndex;
  }
}
